import { FileText, ArrowRight, Monitor } from "lucide-react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", to = "/", testId = "logo" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group inline-flex items-center gap-2 font-poppins font-bold text-zinc-950 ${className}`}
    >
      <span className="inline-flex items-center gap-1.5 rounded-lg bg-zinc-950 px-2 py-1.5 shadow-sm transition-all duration-300 group-hover:-translate-y-0.5">
        <FileText className="h-4 w-4 text-white" strokeWidth={2.25} />
        <ArrowRight className="h-3.5 w-3.5 text-zinc-400" strokeWidth={2.5} />
        <Monitor className="h-4 w-4 text-white" strokeWidth={2.25} />
      </span>
      <span className="text-base sm:text-lg tracking-tight text-zinc-950">
        Register<span className="text-zinc-950">to</span>Digital
      </span>
    </Link>
  );
}
